import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { GETOpeningHoursResponse } from '@cbgms/api'

export const getOpeningHours = () =>
  AsyncAction<GETOpeningHoursResponse>({
    type: [types.LOAD_OPENING_HOURS, types.LOAD_OPENING_HOURS_SUCCESS, types.LOAD_OPENING_HOURS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/work-hours'
      }
    }
  })

export const updateOpeningHours = (data: any) => ({
  type: [types.UPDATE_OPENING_HOURS, types.UPDATE_OPENING_HOURS_SUCCESS, types.UPDATE_OPENING_HOURS_FAILED],
  payload: {
    api: 'gms',
    request: {
      method: 'PUT',
      url: '/modules/work-hours',
      data
    }
  }
})
